<ion-button *ngIf="!!compDefinition" class="full-footer-button"
            [style.--background]="compDefinition.color"
            [style.--color]="compDefinition.contrastColor"
            [style.--background-hover]="altColor"
            [class.selection-option]="selectOption"
            (click)="compClick.emit(compDefinition)">
    <div>
        <span>{{compDefinition.name}}</span>
        <p [class.summary-large]="selectOption"
           [class.summary-small]="!selectOption">
            <span *ngIf="compDefinition.type === compDefinitionTypes.PERCENT">{{compDefinition.amount}}% Off</span>
            <span *ngIf="compDefinition.type === compDefinitionTypes.DEFINED">{{compDefinition.amount | currency}} Off</span>
            <span *ngIf="compDefinition.type === compDefinitionTypes.MANUAL && !!compDefinition.max">Max of {{compDefinition.max | currency}}</span>
        </p>
    </div>
</ion-button>
